/**
 * Created by Ning Jiang on 2024-03-08.
 */

import {WinPresentationController} from "../WinPresentationController";
import {DeadwoodRip} from "../../DeadwoodRip";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap, TimelineLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";
import {RetriggerS1Symbol} from "../../symbol/RetriggerS1Symbol";

export class FreespinRetriggerController extends WinPresentationController {

    constructor() {
        super("FreespinRetriggerController", false);
    }

    protected hasWin():boolean {
        const data = DeadwoodRip.model.parsedGameData;
        const fsUpdate = data.mode != GameMode.FREESPIN_SUPER && data.nextMode === GameMode.FREESPIN_SUPER
        const result = DeadwoodRip.model.parsedGameData.nAdditionalFsAwarded > 1 && !fsUpdate;
        return result;
    }

    protected async createWinAnimation():Promise<any> {
        const image = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures(`fsintro/${DeadwoodRip.model.data.mode === GameMode.FREESPIN_SUPER ? "retrigger_intro_SFS" : "retrigger_intro_FS"}`)[0]);
        image.anchor.set(0.5);
        image.position.set(360, 360);
        const effectSpine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset('bwEffect'));
        effectSpine.autoUpdate = true;
        effectSpine.position.set(360, 360);
        const tl = new TimelineLite();
        tl.add(() => {
            // DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.FREE_SPIN_WIN});
            DeadwoodRip.xBetController.featureVisible = false;
            DeadwoodRip.initialCountUp.remove();
            DeadwoodRip.bigWinCountUp.remove();
            DeadwoodRip.waysWon.remove();
            SlotGame.keypadPlugin.hide();
        });
        let delay = 0.2;
        DeadwoodRip.model.parsedGameData.S1Positions!.forEach((symId, reelId) => {
            if(symId > -1) {
                const symbol = <RetriggerS1Symbol>DeadwoodRip.reels[reelId].getSymbol(symId);
                tl.add(symbol.playRetrigger(), delay);
                delay += 0.5;
            }
        });

        tl.add(() => {
            DeadwoodRip.background.dimScreen(0.7, 0.3, DeadwoodRipLayers.getLayer(Layers.SCREENS)!);
            DeadwoodRipLayers.getLayer(Layers.SCREENS)!.addChild(image);
            DeadwoodRipLayers.getLayer(Layers.SCREENS)!.addChild(effectSpine);
            effectSpine.state.setAnimation(0, `effect`, true);
            // DeadwoodRipSound.fadeMusic(0, 100);
            DeadwoodRipSound.playLoopEffect(DeadwoodRipSound.FREE_SPIN_INTRO);
        });
        tl.add([
            () => {
                DeadwoodRipSound.stopLoopEffect(DeadwoodRipSound.FREE_SPIN_INTRO);
                SlotGame.keypadPlugin.setZeroBetSpinCounter(DeadwoodRip.model.parsedGameData.freespinsLeft);
            },
            gsap.to(effectSpine, {duration : 0.3, alpha : 0}),
            gsap.to(image, {duration : 0.6, alpha : 0}),
            gsap.to(image.scale, {duration : 0.6, x : 2, y : 2}),
            DeadwoodRip.background.dimScreen(0, 0.3)
        ], `+=3`);
        tl.add(() => {
            effectSpine.state.setEmptyAnimations(0);
            effectSpine.parent.removeChild(effectSpine);
            effectSpine.destroy();
            image.parent.removeChild(image);
            image.destroy();
        });
        tl.add(() => {
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S1_FS_HIGHLIGHT});
        }, 0);
        await Promise.resolve(tl);
    }
}